export default "__VITE_ASSET__uYc3gFCd__"